<template>
  <div class="security">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">安全交底配置</span>
      </div>
      <!-- 这里是内容 -->
      <el-row v-loading="loading">
        <el-col :span="17">
          <el-row>
            <!-- 这里是专业 -->
            <el-col :span="8" class="pad0-10">
              <el-card shadow="never">
                <div slot="header" class="clearfix">
                  <h2>专业标签</h2>
                </div>
                专业名称：
                <el-input
                  class="mar-bot10"
                  v-model="addForm.lbst03"
                  placeholder="请输入名称"
                ></el-input
                >位置排序：
                <el-input
                  placeholder="请输入排序"
                  v-model="addForm.lbst08"
                ></el-input>
                <el-button type="primary" class="w100-mar" @click="addzy(1)"
                  >添加</el-button
                >
                <el-row>
                  <el-col :span="5" :offset="1">启用</el-col>
                  <el-col :span="8" :offset="2">专业名称</el-col>
                  <el-col :span="3">排列</el-col>
                  <el-col :span="3" :offset="2">删除</el-col>
                </el-row>
                <div class="lables">
                  <div
                    v-for="(item, index) in zylist"
                    :key="index"
                    class="mar10-0"
                  >
                    <el-row>
                      <el-col :span="4">
                        <el-switch
                          class="mar9-6"
                          v-model="item.lbst07"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          @change="kg(item)"
                        ></el-switch>
                      </el-col>
                      <el-col :span="9" :offset="1">
                        <el-input
                          v-model="item.lbst03"
                          @blur="textLists(item)"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-input
                          v-model="item.lbst08"
                          class="padding0"
                          @blur="textLists(item)"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-button
                          @click="removeLabel(item)"
                          type="danger"
                          icon="el-icon-delete"
                        ></el-button>
                      </el-col>
                    </el-row>
                  </div>
                  <p v-if="zylist.length > 8" class="group-one">滚动更多>></p>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8" class="pad0-10">
              <el-card shadow="never">
                <div slot="header" class="clearfix">
                  <h2>问题标签</h2>
                </div>
                问题名称：
                <el-input
                  class="mar-bot10"
                  v-model="addFormWt.lbst03"
                  placeholder="请输入名称"
                ></el-input
                >位置排序：
                <el-input
                  placeholder="请输入排序"
                  v-model="addFormWt.lbst08"
                ></el-input>
                <el-button type="primary" class="w100-mar" @click="addzy(2)"
                  >添加</el-button
                >
                <el-row>
                  <el-col :span="5" :offset="1">启用</el-col>
                  <el-col :span="8" :offset="2">专业名称</el-col>
                  <el-col :span="3">排列</el-col>
                  <el-col :span="3" :offset="2">删除</el-col>
                </el-row>
                <div class="lables">
                  <div
                    v-for="(item, index) in wtlist"
                    :key="index"
                    class="mar10-0"
                  >
                    <el-row>
                      <el-col :span="4">
                        <el-switch
                          class="mar9-6"
                          v-model="item.lbst07"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          @change="kg(item)"
                        ></el-switch>
                      </el-col>
                      <el-col :span="9" :offset="1">
                        <el-input
                          v-model="item.lbst03"
                          @blur="textLists(item)"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-input
                          v-model="item.lbst08"
                          @blur="textLists(item)"
                          class="padding0"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-button
                          @click="removeLabel(item)"
                          type="danger"
                          icon="el-icon-delete"
                        ></el-button>
                      </el-col>
                    </el-row>
                  </div>
                  <p v-if="wtlist.length > 8" class="group-one">滚动更多>></p>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8" class="pad0-10">
              <el-card shadow="never">
                <div slot="header" class="clearfix">
                  <h2>位置标签</h2>
                </div>
                位置名称：
                <el-input
                  class="mar-bot10"
                  v-model="addFormWz.lbst03"
                  placeholder="请输入名称"
                ></el-input
                >位置排序：
                <el-input
                  placeholder="请输入排序"
                  v-model="addFormWz.lbst08"
                ></el-input>
                <el-button type="primary" class="w100-mar" @click="addzy(3)"
                  >添加</el-button
                >
                <el-row>
                  <el-col :span="5" :offset="1">启用</el-col>
                  <el-col :span="8" :offset="2">专业名称</el-col>
                  <el-col :span="3">排列</el-col>
                  <el-col :span="3" :offset="2">删除</el-col>
                </el-row>
                <div class="lables">
                  <div
                    v-for="(item, index) in wzlist"
                    :key="index"
                    class="mar10-0"
                  >
                    <el-row>
                      <el-col :span="4">
                        <el-switch
                          class="mar9-6"
                          v-model="item.lbst07"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          @change="kg(item)"
                        ></el-switch>
                      </el-col>
                      <el-col :span="9" :offset="1">
                        <el-input
                          v-model="item.lbst03"
                          @blur="textLists(item)"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-input
                          v-model="item.lbst08"
                          class="padding0"
                          @blur="textLists(item)"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        <el-button
                          @click="removeLabel(item)"
                          type="danger"
                          icon="el-icon-delete"
                        ></el-button>
                      </el-col>
                    </el-row>
                  </div>
                  <p v-if="wzlist.length > 8" class="group-one">滚动更多>></p>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7">
          <div class="h400-ov">
            <el-card shadow="never">
              <!-- 这里是审批流程 -->
              <div slot="header">
                <h2>审批流程</h2>
              </div>
              <div>
                <el-button
                  type="primary"
                  class="w100-mar26-0-20"
                  @click="approvalOpen"
                  >添加</el-button
                >
                <div class="mar-bot10">
                  <el-row v-for="(item, index) in approvalList" :key="index">
                    <el-col :span="5">
                      <el-select
                        filterable
                        v-model="item.Type"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item2, index2) in options"
                          :key="index2"
                          :label="item2.label"
                          :value="item2.value"
                          @click.native="changeshenp(item, item2)"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="13" :offset="1">
                      <el-row>
                        <el-col
                          :span="8"
                          class="mar-bot10"
                          v-for="(item2, index2) in item.Aus"
                          :key="index2"
                        >
                          <div class="mar0a-w42">
                            <img
                              width="42px"
                              height="42px"
                              :src="$store.state.baseUrl + item2.image"
                            />
                          </div>
                          <p class="group-tow">{{ item2.Name }}</p>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="4" :offset="1">
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        @click="delAtta(item)"
                      ></el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </div>
          <!-- 这里是抄送流程 -->
          <div class="h340-ov-a">
            <el-card shadow="never" class="mar-top6">
              <div slot="header">
                <h2>抄送流程</h2>
              </div>
              <div>
                <el-button
                  type="primary"
                  class="w100-mar26-0-20"
                  @click="copyProcessOpen"
                  >添加</el-button
                >
                <el-row>
                  <el-col
                    class="mar-bot10"
                    :span="4"
                    v-for="(item, index) in copyProcessList.Aus"
                    :key="index"
                  >
                    <div class="mar-pos-re">
                      <img
                        width="42px"
                        height="42px"
                        :src="$store.state.baseUrl + item.image"
                      />
                      <div @click="delAttaUser(item)" class="group-three">
                        X
                      </div>
                    </div>
                    <p class="group-tow">{{ item.Name }}</p>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="添加审批流程"
      :visible.sync="approval"
      width="30%"
      :before-close="handleClose2"
    >
      <span>添加审批流程</span>
      <el-table
        ref="multipleTable"
        :data="ProjectUserList"
        tooltip-effect="dark"
        class="width100"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="user04"
          label="同户名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="user11"
          label="手机号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="user12"
          label="邮箱"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-select filterable v-model="value2" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" v-if="btnShow" @click="addapproval"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="添加抄送流程"
      :visible.sync="copyProcess"
      width="30%"
      :before-close="handleClose"
    >
      <span>添加抄送流程</span>
      <el-table
        ref="multipleTable"
        :data="ProjectUserList"
        tooltip-effect="dark"
        class="width100"
        @selection-change="handleSelectionChange2"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="user04"
          label="同户名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="user11"
          label="手机号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="user12"
          label="邮箱"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="btnShow2" @click="addCopyProcess"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetLabelList,
  AddLabelList,
  RemoveLabelListss,
  UpdateLabelListss,
  GetDesignUser,
  GetMember,
  GetAuditUserList,
  AddAuditUser,
  AddCCUser,
  UpdatePworkFlow,
  delAtta,
  delAttaUser,
} from "@/setAxios.js";
export default {
  name: "security",
  data() {
    return {
      btnShow: true,
      btnShow2: true,
      // 审批
      approval: false,
      // 抄送
      copyProcess: false,
      // 审批流程
      approvalList: [],
      // 抄送流程
      copyProcessList: [],
      ProjectUserList: [],
      multipleSelection: [],
      multipleSelection2: [],
      approvalListLength: 0,
      copyProcessListLength: "",
      zylist: [],
      wzlist: [],
      wtlist: [],
      addForm: {
        lbst01: 0,
        lbst02: localStorage.getItem("xid"),
        lbst03: null,
        lbst04: null,
        lbst05: 3,
        lbst06: new Date(),
        lbst07: 1,
        lbst08: null,
      },
      addFormWt: {
        lbst01: 0,
        lbst02: localStorage.getItem("xid"),
        lbst03: null,
        lbst04: null,
        lbst05: 3,
        lbst06: new Date(),
        lbst07: 1,
        lbst08: null,
      },
      addFormWz: {
        lbst01: 0,
        lbst02: localStorage.getItem("xid"),
        lbst03: null,
        lbst04: null,
        lbst05: 3,
        lbst06: new Date(),
        lbst07: 1,
        lbst08: null,
      },
      options: [
        {
          value: 1,
          label: "或签",
        },
        {
          value: 2,
          label: "会签",
        },
      ],
      value2: "",
      majorName: "",
      rank: "",
      // 是否启用
      startUsing: true,
      loading: false,
    };
  },
  methods: {
    delAttaUser(data) {
      //(data);
      let params = {
        xid: localStorage.getItem("xid"),
        uid: data.Uid,
        type: 3,
      };
      delAttaUser(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.aa();
        }
      });
    },
    // 删除审批流程
    delAtta(row) {
      //(row);
      let params = {
        id: row.id,
      };
      delAtta(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.aa();
        }
      });
    },
    // 修改或签会签

    changeshenp(data1, data2) {
      //(data1, data2);
      let params = {
        type: data2.value,
        flowid: data1.Aus[0].GroupType,
      };
      UpdatePworkFlow({ ...params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.aa();
        }
      });
    },
    addapproval() {
      if (this.value2 == "") {
        this.$message({
          type: "warning",
          message: "请选择类型",
        });
      } else {
        if (this.multipleSelection.length > 0) {
          this.btnShow = false;
          let uid = [];
          this.multipleSelection.forEach((ele) => {
            uid.push(ele.user01);
          });
          let params = {
            WorkType: this.value2,
            Uids: uid,
            Order: this.approvalListLength + 1,
            Xid: localStorage.getItem("xid"),
            WorkFlowType: 3,
          };
          AddAuditUser({ model: JSON.stringify(params) }).then((res) => {
            if (res.Code > 0) {
              //(res, "添加审批流程");
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.approval = false;
              this.aa();
              this.multipleSelection = [];
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: "请先选择审批人",
          });
        }
      }
    },
    addCopyProcess() {
      if (this.multipleSelection2.length > 0) {
        this.btnShow2 = false;
        let uid = [];
        this.multipleSelection2.forEach((ele) => {
          uid.push(ele.user01);
        });
        let params = {
          WorkType: 1,
          Uids: uid,
          Order: this.copyProcessListLength + 1,
          Xid: localStorage.getItem("xid"),
          WorkFlowType: 3,
        };
        AddCCUser({ model: JSON.stringify(params) }).then((res) => {
          if (res.Code > 0) {
            //(res, "添加审批流程");
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.copyProcess = false;
            this.aa();
            this.multipleSelection2 = [];
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先选择审批人",
        });
      }
    },
    approvalOpen() {
      this.btnShow = true;
      this.approval = true;
      let params = {
        xid: localStorage.getItem("xid"),
        type: 3,
      };
      GetAuditUserList({ params }).then((res) => {
        this.ProjectUserList = res.Data;
        //(res, "人员");
      });
    },
    copyProcessOpen() {
      this.btnShow2 = true;
      this.copyProcess = true;
      let params = {
        xid: localStorage.getItem("xid"),
        type: 3,
      };
      GetAuditUserList({ params }).then((res) => {
        this.ProjectUserList = res.Data;
        //(res, "人员");
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //(this.multipleSelection);
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      //(this.multipleSelection2);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose2(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //是否启用按钮
    kg(i) {
      i.lbst07 = i.lbst07 === true ? 1 : 0;
      let params = JSON.stringify(i);
      UpdateLabelListss({ model: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: i.lbst07 === 1 ? "开启" : "关闭",
          });
          this.getData();
        }
      });
    },
    // 获取所有数据
    getData() {
      var params = {
        xid: localStorage.getItem("xid"),
        type: 3,
      };
      GetLabelList({ params }).then((res) => {
        //(res, "lable");
        this.zylist = res.Data.zy;
        this.wtlist = res.Data.wt;
        this.wzlist = res.Data.wz;
        class FOR {
          constructor() {}
          ss(i) {
            i.forEach((item, index) => {
              if (item.lbst07 === 1) {
                item.lbst07 = true;
              } else {
                item.lbst07 = false;
              }
            });
          }
        }
        let forss = new FOR();
        forss.ss(this.zylist);
        forss.ss(this.wtlist);
        forss.ss(this.wzlist);
      });
    },
    aa() {
      var params = {
        xid: localStorage.getItem("xid"),
        type: 3,
      };
      GetDesignUser({ params }).then((res) => {
        //(res, "安全交底");
        if (res.Data.length > 0) {
          if (res.Data[0].OrderNum == 0 || res.Data.Type == "") {
            this.copyProcessList = res.Data[0];
            if (res.Data.length > 1) {
              this.approvalList = res.Data.slice(1);
              this.approvalListLength =
                this.approvalList[
                  this.approvalList.length - 1
                ].Aus[0].GroupType;
            } else {
              this.approvalList = [];
            }
          } else {
            this.copyProcessList = [];
            this.approvalList = res.Data;
            this.approvalListLength =
              this.approvalList[this.approvalList.length - 1].Aus[0].GroupType;
          }
        } else {
          this.approvalList = [];
          this.copyProcessList = [];
          //("无数据");
        }
      });
    },
    // 新增专业标签
    addzy(i) {
      let title = "";
      let params = null;
      if (i === 1) {
        title = "成功添加专业标签";
        this.addForm.lbst04 = i;
        if (this.addForm.lbst03 == null || this.addForm.lbst08 == null) {
          this.$message({
            type: "warning",
            message: "请补充完整后添加",
          });
          return;
        }
        params = JSON.stringify(this.addForm);
      } else if (i === 2) {
        title = "成功添加问题标签";
        this.addFormWt.lbst04 = i;
        if (this.addFormWt.lbst03 == null || this.addFormWt.lbst08 == null) {
          this.$message({
            type: "warning",
            message: "请补充完整后添加",
          });
          return;
        }
        params = JSON.stringify(this.addFormWt);
      } else if (i === 3) {
        title = "成功添加位置标签";
        this.addFormWz.lbst04 = i;
        if (this.addFormWz.lbst03 == null || this.addFormWz.lbst08 == null) {
          this.$message({
            type: "warning",
            message: "请补充完整后添加",
          });
          return;
        }
        params = JSON.stringify(this.addFormWz);
      }
      AddLabelList({ model: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: title,
          });
          this.addForm = this.$options.data().addForm;
          this.addFormWt = this.$options.data().addFormWt;
          this.addFormWz = this.$options.data().addFormWz;
          this.getData();
        }
      });
    },
    removeLabel(item) {
      //(item);
      let params = JSON.stringify(item.lbst01);
      RemoveLabelListss({ id: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getData();
        }
      });
    },
    textLists(i) {
      i.lbst07 = i.lbst07 === true ? 1 : 0;
      //(i, "i");
      let params = JSON.stringify(i);
      UpdateLabelListss({ model: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "修改为：" + i.lbst03,
          });
          this.getData();
        }
      });
    },
  },
  created() {
    this.getData();
    this.aa();
  },
};
</script>

<style lang="less"></style>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}
.pad0-10 {
  padding: 0 10px;
}
.mar-bot10 {
  margin-bottom: 10px;
}
.w100-mar {
  width: 100%;
  margin: 10px 0 20px;
}
.lables {
  margin: 10px 0;
  height: 404px;
  overflow-x: hidden;
  width: 332px;
  padding-right: 30px;
}
.mar10-0 {
  margin: 10px 0;
}
.mar9-6 {
  margin: 9px 6px;
}
.padding0 {
  padding: 0;
}
.group-one {
  position: absolute;
  bottom: 10px;
  margin-left: 130px;
  color: #409eff;
}
.h400-ov {
  height: 400px;
  overflow: auto;
}
.w100-mar26-0-20 {
  width: 100%;
  margin: 26px 0 20px;
}
.mar0a-w42 {
  margin: 0 auto;
  width: 42px;
}
.group-tow {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 58px;
  margin: 0 auto;
}
.h340-ov-a {
  height: 340px;
  overflow: auto;
}
.mar-top6 {
  margin-top: 6px;
}
.mar-pos-re {
  margin: 0 auto;
  width: 42px;
  position: relative;
}
.group-three {
  background: red;
  color: #fff;
  width: 15px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  top: -6px;
  right: -6px;
}
.width100 {
  width: 100%;
}
</style>
